import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApiMiddlewarePayload } from '@ocean/api'
import { ApiAction, createApiAction } from 'api'
import { userLoggedOut } from 'core/session/slices/session'
import { getData } from 'modules/activityLog/details/CertificateLogDetails/api/certificateLogDetailsService'
import { CertificateLogDetailsState, ApiCertificateLogDetailsResponse } from './types'

const initialState: CertificateLogDetailsState = {
  data: {},
}

const certificateLogDetailsSlice = createSlice({
  name: 'activityLogCertificateLogDetails',
  initialState,
  reducers: {
    dataLoaded(
      state,
      action: PayloadAction<ApiMiddlewarePayload<ApiCertificateLogDetailsResponse>>
    ) {
      state.data = action.payload
    },
  },
  extraReducers: builder => {
    builder.addCase(userLoggedOut, () => {
      return initialState
    })
  },
})

const { dataLoaded } = certificateLogDetailsSlice.actions

export default certificateLogDetailsSlice.reducer

export const loadData = (): ApiAction => {
  return createApiAction({
    apiCalls: {
      info: getData,
    },
    payloadAction: dataLoaded,
  })
}
